import htmlTemplateMenu from './menu.html'
import { applyHtmlRestrictions } from '../../helpers/restrictions/apply-html-restrictions.js'
import { setElementHtml } from '../../helpers/generic-js/dom.js'

const headerMenuElementId = 'layoutHeaderMenu'

export function showPageHeaderMenu (params) {
  // console.log('showPageHeaderMenu', params)
  const { browserAppAccount, browserAppUser } = params

  let htmlMenu = htmlTemplateMenu
  htmlMenu = applyHtmlRestrictions(htmlMenu, { browserAppAccount, browserAppUser })

  setElementHtml(headerMenuElementId, htmlMenu)

  activateMobileBurgerMenu()
}

// Only load the listeners once
let isMenuListenerLoaded = false

/**
 * From Bulma: https://bulma.io/documentation/components/navbar/#navbar-menu
 */
function activateMobileBurgerMenu () {
  if (isMenuListenerLoaded) return

  // Get all "navbar-burger" elements
  const $navbarBurgers = document.querySelectorAll('.navbar-burger')

  // Add a click event on each of them
  $navbarBurgers.forEach(function (oneBurgerMenu) {
    oneBurgerMenu.addEventListener('click', function () {
      // Get the target from the "data-target" attribute
      const targetElementId = oneBurgerMenu.getAttribute('data-target')
      const targetElement = document.getElementById(targetElementId)

      // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
      oneBurgerMenu.classList.toggle('is-active')
      targetElement.classList.toggle('is-active')
    })
  })
  isMenuListenerLoaded = true
}
